import TransactionModal from "./transactionModal.js";

export default class TerminateGrantsModal extends TransactionModal {
  constructor(companyId) {
    super("terminate-grants-modal", companyId);

    this.$date = this.$form.querySelector('[name="date"]');

    this.formFields = [
      {
        name: "date",
        varType: "string",
        required: true,
      },
      {
        name: "leave_type",
        varType: "int",
        required: true,
      },
      {
        name: "termination_reason",
        varType: "string",
      }
    ];

    this.setupForm();
    this.whenReady();
  }

  setStakeholder(stakeholderId, grantId) {
    if (stakeholderId === this.stakeholderId && grantId === this.grantId) {
      return;
    }
    this.stakeholderId = stakeholderId;
    this.grantId = grantId;
    this.setupGrants();
  }

  removeListedGrants() {
    this.$form.querySelectorAll("[data-grant]").forEach((el) => {
      el.remove();
    });
  }

  setupForm() {
    this.$date.valueAsDate = new Date();

    this.$date.addEventListener("change", () => {
      if (typeof this.timeout !== "undefined") {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.setupGrants();
      }, 1000);
    });
  }

  setupGrants() {
    return new Promise((resolve, reject) => {
      peque
        .api(
          "grants",
          {
            company: this.companyId,
            stakeholder: this.stakeholderId,
            vesting_date: this.$date.value,
            full: true,
          },
          "get"
        )
        .then((response) => {
          this.removeListedGrants();
          const list = [];

          response.result.list.forEach((grant) => {
            if (!!this.grantId && grant.id !== this.grantId) {
              return;
            }

            const canFraction = !(grant.plan.grant_type >= 2 && grant.plan.grant_type <= 4);
            const template = peque.parseTemplate("terminate-grant-details", {
              id: grant.id,
              name: grant.plan.name,
              amount: grant.amount,
              purchase_price: grant.purchase_price,
              vested: grant.leave_date
                ? grant.vested_amount
                : canFraction? grant.vested_amount : Math.floor(grant.vested_amount),
              grant: grant,
            });

            if (grant.purchase_price) {
              const $cost = template.querySelector("[data-vested-cost]");
              const $input = template.querySelector("input");
              $input.addEventListener("input", () => {
                $cost.innerText =
                  peque.formatNumber(
                    grant.purchase_price * parseFloat($input.value)
                  ) +
                  " " +
                  window.currentCompany.currency;
              });
            }

            this.$form.append(template);
          });

          this.setupAllDocumentContainers().then(() => {
            resolve(list);
          });
        });
    });
  }

  setupAllDocumentContainers() {
    this.documentSelects = [];
    return new Promise((resolve, reject) => {
      this.getDocuments().then((list) => {
        this.$form
          .querySelectorAll("[data-documents-section]")
          .forEach((el) => {
            const $documentSelector = el.querySelector(
              "[data-document-selector]"
            );
            const $documentContainer = el.querySelector(
              '[data-container="documents"]'
            );

            list.forEach((doc) => {
              const el = document.createElement("option");
              el.innerText = doc.name;
              el.value = doc.id;
              el.dataset.link = doc.link;
              $documentSelector.appendChild(el);
            });

            this.documentSelects.push(
              this.setupDocumentSelector($documentSelector, $documentContainer)
            );
          });
      });
    });
  }

  validateAndSendForm() {
    const grants = [];
    this.$form.querySelectorAll("[data-grant]").forEach((el) => {
      const documents = [];
      el.querySelectorAll('[name="documents[]"]').forEach((input) => {
        documents.push(parseInt(input.value));
      });
      grants.push({
        id: parseInt(el.dataset.grant),
        amount: parseFloat(el.querySelector('[name="amount"]').value),
        documents: documents,
      });
    });

    this.getFields(this.formFields)
      .then((data) => {
        data.grants = grants;

        peque
          .api("grants/bulk_exercise", JSON.stringify(data), "post")
          .then((response) => {
            location.reload();
          });
      })
      .catch((error) => {
        if (typeof error.el === "undefined") {
          throw error;
        }
        this.showErrorOnField(error.message, error.el);
      });
  }
}
